module.exports = __webpack_public_path__ + "static/img/WQX.38d6ad02.png";